var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9108_40418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 15.955C17.9746 14.1879 19.2171 11.6199 19.2171 8.7617C19.2171 5.90348 17.9746 3.33548 16.0002 1.56836C14.0258 3.33548 12.7833 5.90348 12.7833 8.7617C12.7833 11.6199 14.0258 14.1879 16.0002 15.955Z",
    stroke: "#4BDACC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 30.4311C17.9746 28.664 19.2171 26.096 19.2171 23.2378C19.2171 20.3795 17.9746 17.8115 16.0002 16.0444C14.0258 17.8115 12.7833 20.3795 12.7833 23.2378C12.7833 26.096 14.0258 28.664 16.0002 30.4311Z",
    stroke: "#4BDACC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9555 15.9997C14.1884 14.0254 11.6204 12.7828 8.76219 12.7828C5.90397 12.7828 3.33596 14.0254 1.56885 15.9997C3.33596 17.9741 5.90397 19.2166 8.76219 19.2166C11.6204 19.2166 14.1884 17.9741 15.9555 15.9997Z",
    stroke: "#4BDACC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4316 15.9997C28.6645 14.0254 26.0965 12.7828 23.2382 12.7828C20.38 12.7828 17.812 14.0254 16.0449 15.9997C17.812 17.9741 20.38 19.2166 23.2382 19.2166C26.0965 19.2166 28.6645 17.9741 30.4316 15.9997Z",
    stroke: "#4BDACC",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9108_40418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.ca83207d0d66ff310765fdbd4be11df8.svg";
export { ForwardRef as ReactComponent };